import React from "react";
import PropTypes from "prop-types";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import styles from "./styles.module.css";
import moment from "moment";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  makePaymentHash,
  oneTimePayment,
  createNewPaymentHistory,
  updateSubscription,
  getSubscriptionDetails,
} from "../../../actions";
import { showAlert } from "../../../../../common/actions";
import Loading from "../../../../../common/components/Loading";

const merchant_id = process.env.REACT_APP_PAY_HERE_MERCHANT_ID;
const return_url = process.env.REACT_APP_PAY_HERE_RETURN_URL;
const cancel_url = process.env.REACT_APP_PAY_HERE_CANCEL_URL;
const notify_url = process.env.REACT_APP_PAY_HERE_NOTIFY_URL;
const country = process.env.REACT_APP_PAY_HERE_COUNTRY;
const currency = process.env.REACT_APP_PAY_HERE_CURRENCY;
const item = process.env.REACT_APP_PAY_HERE_ITEM;
const service_id = process.env.REACT_APP_SERVICE_ID;
/** Preapproval notify: backend maps custom_2 to subscription plan id */
const PREAPPROVAL_PLAN_ID = 2;



const PayableCard = ({  
  handlePayNow,
  setIsPayNowBoxOpen,
  isPayNowBoxOpen,
  makePaymentHash,
  createNewPaymentHistory,
  updateSubscription,
  getSubscriptionDetails,
  showAlert,
  onCancelSubscription,
  payment: {
    isSubscriptionDetailsLoading,
    isGetAllSubscriptionPlansLoading,
    subscriptionPlans,
    subscriptionUserFirstName,
    subscriptionUserLastName,
    subscriptionUserEmail,
    subscriptionUserPhone,
    subscriptionUserAddress,
    subscriptionUserCity,
    subscriptionUserId,
    subscriptionId,
    subscriptionPlanName,
    subscriptionPlanAmount,
    subscriptionCurrentPeriodEndAt,
    subscriptionIsRecurring,
    subscriptionCardNumber,
  },
  auth
}) => {

  useEffect(() => {
    handleGenerateHash();
  }, []);

  const [isCardAddingPending, setIsCardAddingPending] = useState(false);
  const hasCardOnSubscription = Boolean(subscriptionCardNumber);
  const isRecurringEnabled = Boolean(subscriptionIsRecurring);

  useEffect(() => {
    setIsCardAddingPending(!hasCardOnSubscription);
  }, [isRecurringEnabled, hasCardOnSubscription]);

  const disableSubscribeBySubscriptionState =
    hasCardOnSubscription;
  const disableCancelBySubscriptionState = isCardAddingPending;

    const location = useLocation();

    const [orderId, setOrderId] = useState(null);
    const [hash, setHash] = useState(null);
    
  // make plan name correctly
  function capitalizeFirstLetter(string) {
    if (!string) return ""; // Check for empty or undefined string
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }

  // format plan amount
  function formatNumber(number) {
    return number && number.toFixed(2);
  }

  // Generate Order ID
  const generateOrderId = () => {
    const randomNum = Math.floor(10000000 + Math.random() * 90000000);
    const generatedId = randomNum.toString();
    setOrderId(generatedId);
    return generatedId;
  };

  // Handle Hash Generation
  const handleGenerateHash = async () => {
    const generatedOrderId = generateOrderId();
    try {
      const body = {
        orderId: generatedOrderId,
        amount:30.00,
        currency: currency,
      };

      const response = await makePaymentHash(body);

      if (response) {
        setHash(response); 
      } else {
        throw new Error("Failed to generate hash");
      }
    } catch (error) {
      console.error("Error generating hash:", error);
      setHash(null);
    }
  };

  const submitSubscriptionPay = async () => {


    if (!orderId || !hash) {
      console.error(
        "Order ID or Hash is missing. Ensure hash is generated before payment."
      );
      return;
    }

    let paymentDetails = {
      sandbox: false,
      merchant_id: merchant_id,
      return_url: return_url,
      cancel_url: cancel_url,
      notify_url: notify_url,
      first_name:
        subscriptionUserFirstName && subscriptionUserFirstName,
      last_name:
        subscriptionUserLastName && subscriptionUserLastName,
      email: subscriptionUserEmail && subscriptionUserEmail,
      phone: subscriptionUserPhone && subscriptionUserPhone,
      address:
        subscriptionUserAddress && subscriptionUserAddress,
      city: subscriptionUserCity && subscriptionUserCity,
      country: country,
      order_id: orderId,
      items: item,
      currency: currency,
      amount: 30.00,
      hash: hash,
      preapprove: true,
      custom_1: Number(subscriptionUserId),
      custom_2: Number(PREAPPROVAL_PLAN_ID),
    };


    window.payhere.startPayment(paymentDetails);

    // Called when user completed the payment. It can be a successful payment or failure
    window.payhere.onCompleted = function onCompleted(OrderID, method) {

      console.log("onCompleted", OrderID, method);

      getSubscriptionDetails({
        companyId: auth.companyId && auth.companyId,
        serviceId: parseInt(service_id, 10),
      });
    
      // setIsCardAddingPending(true);
      // if (!subscriptionIsRecurring) {
      //   updateSubscription(subscriptionId);
      // }

      // showAlert({
      //   isAlertOpen: true,
      //   alertType: "success",
      //   alertMessage: "Payment was successful!",
      // });

      
    };

    // Called when user closes the payment without completing
    window.payhere.onDismissed = function onDismissed() {

     
      showAlert({
        isAlertOpen: true,
        alertType: "danger",
        alertMessage: "Payment was dismissed!",
      });
    };

    // Called when error happens when initializing payment such as invalid parameters
    window.payhere.onError = function onError(error) {

    
      showAlert({
        isAlertOpen: true,
        alertType: "danger",
        alertMessage: "Payment failed!",
      });
    };


  };

  const handleCancelSubscription = () => {
    if (!subscriptionId) return;
    const confirmed = window.confirm(
      "Are you sure you want to cancel your subscription? You will not be charged for the next billing period."
    );
    if (confirmed) {
      if (onCancelSubscription) {
        onCancelSubscription(subscriptionId);
      } else {
        showAlert({
          isAlertOpen: true,
          alertType: "info",
          alertMessage: "Cancel subscription requested. Please contact support if this does not complete.",
        });
      }
    }
  };

  return (
    <div className={styles.topCard}>
      {isSubscriptionDetailsLoading ? (
        <div className={styles.loadingContainer}>
          <Loading />
        </div>
      ) : (
        <>
      <div className={styles.membershipTag}>
        {capitalizeFirstLetter(subscriptionPlanName)} plan
      </div>
      
      <div className={styles.payableContainer}>
        <div className={styles.totalPayableSection}>
          <div className={styles.totalPayableLabel}>Total Payable</div>
          <div className={styles.totalPayableAmount}>
            LKR {formatNumber(subscriptionPlanAmount)}
          </div>
        </div>
        
        <div className={styles.actionSection}>
          <div className={styles.buttonRow}>
            <button 
              disabled={disableCancelBySubscriptionState}
              type="button"
              className={styles.cancelSubscriptionButton}
              onClick={handleCancelSubscription}
            >
              Cancel Subscription
            </button>
            <button
              type="button"
              disabled={
                disableSubscribeBySubscriptionState ||
                !subscriptionUserFirstName ||
                !subscriptionUserLastName ||
                !subscriptionUserEmail ||
                !subscriptionUserPhone
              }
              className={styles.payNowButton}
              onClick={() => submitSubscriptionPay()}
            >
              SUBSCRIBE
            </button>
          </div>
          {(!subscriptionUserFirstName ||
              !subscriptionUserLastName ||
              !subscriptionUserEmail ||
              !subscriptionUserPhone) && (
                <div className={styles.payerDetailsHint}>
                  Add Payer Details to proceed with your payment
                </div>
              )}
          {/* {isCardAddingPending && (
            <div className={styles.payerDetailsHint}>
              Card adding is pending. Please wait until card setup is completed.
            </div>
          )} */}
          
          <div className={styles.nextPayment}>
            Next Payment Due:{" "}
            {subscriptionCurrentPeriodEndAt &&
              moment(subscriptionCurrentPeriodEndAt).format("MMMM D, YYYY")}
          </div>
        </div>
      </div>
        </>
      )}
    </div>
  );
};

PayableCard.propTypes = {
  setTabChangeValue: PropTypes.func,
  handlePayNow: PropTypes.func,
  makePaymentHash: PropTypes.func.isRequired,
  oneTimePayment: PropTypes.func.isRequired,
  showAlert: PropTypes.func.isRequired,
  createNewPaymentHistory: PropTypes.func.isRequired,
  updateSubscription: PropTypes.func.isRequired,
  getSubscriptionDetails: PropTypes.func.isRequired,
  onCancelSubscription: PropTypes.func,
};

const mapStateToProps = (state) => ({
    payment: state.paymentState,
    auth: state.authState,
    common: state.commonState,
  });

export default connect(mapStateToProps, {  makePaymentHash,
    oneTimePayment,
    showAlert,
    createNewPaymentHistory,
    updateSubscription,
    getSubscriptionDetails})(PayableCard);
